(function() {

    // Add the directive to the module
    angular.module("Sinewav3.Client.Shell")
        .directive(
            'navTabs',
            [
                'CHROME',
                NavTabsFactory
            ]
        );

    // Factory Method
    function NavTabsFactory(CHROME)
    {
        // Construct and return the instance
        return {
            restrict: 'E',
            templateUrl: CHROME.PREFIX + CHROME.TABS.TEMPLATE + CHROME.POSTFIX
        };

    }
})();



